import {
  LEAD_CONVERSION_PROBABILITIES,
  LeadProbabilityPivotData,
  LeadProbabilityStageCell,
} from "../models/Dashboard/LeadAnalytics/LeadAnalytics";
import {
  resolveStageKey,
  sortStagesForPipeline,
} from "../models/Dashboard/LeadAnalytics/leadPipelineStageOrder";

const normalizeStageName = (value: string) => value.trim().toLowerCase();

export const buildLeadProbabilityPivot = (
  cells: LeadProbabilityStageCell[],
  stageOrder?: string[],
): LeadProbabilityPivotData => {
  const countMap = new Map<string, number>();
  const stagesInData = new Set<string>();

  cells.forEach((cell) => {
    const stageName = resolveStageKey(cell.stage_name?.trim() || "-", stageOrder);
    const stageKey = normalizeStageName(stageName);
    const probabilityKey = `${cell.conversion_probability}|${stageKey}`;
    countMap.set(probabilityKey, (countMap.get(probabilityKey) ?? 0) + cell.lead_count);
    stagesInData.add(stageName);
  });

  const stages = sortStagesForPipeline(Array.from(stagesInData), stageOrder);

  const rows = LEAD_CONVERSION_PROBABILITIES.map((probability) => {
    const counts: Record<string, number> = {};
    let rowTotal = 0;

    stages.forEach((stage) => {
      const count = countMap.get(`${probability}|${normalizeStageName(stage)}`) ?? 0;
      counts[stage] = count;
      rowTotal += count;
    });

    return { probability, counts, rowTotal };
  });

  return { stages, rows };
};
